// Auto-generated by scripts/generateFactionSkinConfig.mjs
// Do not edit manually.

// eslint-disable-next-line no-unused-vars
import {FACTIONS} from '../../../constants/factions';
// eslint-disable-next-line no-unused-vars
import {PLAYER_COLORS} from '../../colors';

export const FACTION_SKINS_GREMLINS = [{
  id: 'gremlins_tech',
  factionId: FACTIONS.GREMLINS,
  name: 'Полевой инженер',
  priceNumens: 8000,
  skinRank: 1,
  colors: [
    PLAYER_COLORS.LIGHT_GREEN,
    PLAYER_COLORS.ORANGE,
    PLAYER_COLORS.DARK_GREEN,
  ]
}, {
  id: 'gremlins_seller',
  factionId: FACTIONS.GREMLINS,
  name: 'Торговец шестернями',
  priceNumens: 35000,
  skinRank: 2,
  colors: [
    PLAYER_COLORS.ORANGE,
    PLAYER_COLORS.YELLOW,
  ]
}, {
  id: 'gremlins_ancient',
  factionId: FACTIONS.GREMLINS,
  name: 'Древний мастер',
  priceNumens: 85000,
  skinRank: 3,
  colors: [
    PLAYER_COLORS.LIGHT_GREEN,
  ]
}, {
  id: 'gremlins_gold_legacy',
  factionId: FACTIONS.GREMLINS,
  name: 'Творец автоматонов',
  priceNumens: 70000,
  skinRank: 3,
  colors: [
    PLAYER_COLORS.YELLOW,
  ],
  excludedFromChests: true
}, {
  id: 'gremlins_ruby_legacy',
  factionId: FACTIONS.GREMLINS,
  name: 'Главный конструктор',
  priceCrystals: 350,
  skinRank: 4,
  colors: [
    PLAYER_COLORS.LIGHT_GREEN,
    PLAYER_COLORS.RED,
  ],
  accentColor: PLAYER_COLORS.RED,
  excludedFromChests: true
}];
